// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterColumn_wrapper__m2GP3","header":"FooterColumn_header__11mnO","body":"FooterColumn_body__f1DJq"};